import { useMemo } from "react";
import type { configType } from "../types";
import { computeMetricValue } from "./computeMetric";
import { StatNumber } from "./StatNumber";
import { DonutRing } from "./DonutRing";

interface MetricCardVisualizationProps {
  rows: Record<string, unknown>[];
  /** Denominator rows for donut style (total or filter source). Null = use config.denominatorFixed. */
  denominatorRows?: Record<string, unknown>[] | null;
  config: configType;
  isLoading: boolean;
  deletePlot?: (plotId: string) => void;
  hidePlot?: (plotId: string) => void;
  editPlot?: (plotInfo: any) => void;
}

export const MetricCardVisualization = ({
  rows,
  denominatorRows = null,
  config,
  isLoading,
}: MetricCardVisualizationProps) => {
  const mc = config.metricCard;

  // Compute value unconditionally (hooks must not be conditional)
  const value = useMemo(() => {
    if (!mc || !rows?.length) return 0;
    return computeMetricValue(rows, mc);
  }, [rows, mc]);

  if (!mc) {
    return (
      <div className="flex items-center justify-center w-full h-full p-4">
        <p className="text-[#8C8C8C] text-sm">No metric configured.</p>
      </div>
    );
  }

  if (mc.displayStyle === "donut") {
    return (
      <DonutRing
        numeratorRows={rows}
        denominatorRows={denominatorRows}
        config={config}
        isLoading={isLoading}
      />
    );
  }

  // Default: number style (with optional delta indicator)
  return (
    <StatNumber
      value={value}
      rows={rows}
      config={config}
      isLoading={isLoading}
    />
  );
};
